import React, { useState, useContext, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box, Flex, Text, Button, Image } from 'rebass';
import { BiEditAlt } from "react-icons/bi";
import { IoBookOutline } from "react-icons/io5";
import { IoIosArrowBack } from 'react-icons/io';

import store from 'store';
import Confetti from 'react-confetti';
import { useWindowSize } from 'react-use';

import { useCurrentCollectionRoute } from 'collections/hooks/index';
import { setCheckmark, setSidebar } from '../../ui/actions';
import { useMatch } from '../../app/hooks';
import useLocation from 'app/hooks/location';
import { CurrentCollectionContext } from 'collections/current-collection-context';
import { CgHome } from "react-icons/cg";
import { BiMenu } from "react-icons/bi";
import Options from './options';
import Modal from 'app/modal/v3/index';
import DetailHeaderButton from '../../app/detail/button';
import DetailNavOuter from '../../app/detail/nav-outer';
import greybfylogo from 'babys-first-year/assets/greybfylogo.png';
import whitebfylogo from 'babys-first-year/assets/whitebfylogo.png';
import { togglefirstTimeUserFlowVisible, toggleFtuiFinalStepVisible } from 'stories/actions';
import Congratulations from '../assets/Congratulations.png';
import { LetsBeginFooterComponent } from 'stories/new/global/lets-begin';
import ftuiReviewStory from 'stories/assets/ftui-review-story.png';
import { useFirstTimeUserFlowVisible, useFtuiFinalStepVisible } from 'stories/hooks/index';
import { useInitBookPages, BOOK_PAGES_STATES } from 'stories/book-pages-context';
import AppInstallModal from './TimeSavingTip';

const MainOptions = [
  {
    icon: (color = "#0E0E0E") => <CgHome size={24} color={color} />, label: <>
      <i>In your stories home dashboard</i>
      <ul style={{ listStyle: 'none', fontFamily: "Poppins", fontFamily: '15px', color: "#000", marginBottom: '0px', marginTop: '10px' }}>
        <li>1. Add a <b>new story</b></li>
      </ul>
    </>
  },
  {
    icon: (colour = "#0E0E0E") => <BiMenu size={24} color={colour} />, label: <>
      <i>In your sidebar menu</i>
      <ul style={{ listStyle: 'none', fontFamily: "Poppins", fontFamily: '15px', color: "#000", marginBottom: '0px', marginTop: '10px' }}>
        <li>2. <b> Request a story</b> from someone</li>
        <li>3. Explore other special features</li>
      </ul>
    </>
  },
];
let alreadySeen = false

const StoryDetailHeaderNav = ({ refreshBookPages, footerSx, isFromEdit, isFirstTimeUser, setFirstTimeUserModal }) => {
  const { params: { id } } = useMatch();
  const { pathname, state } = useLocation();
  const { push, goBack } = useHistory();
  const dispatch = useDispatch();
  const { width, height } = useWindowSize();
  const [showSubmit, setShowSubmit] = useState(false);
  const [showTimeSavingTip, setShowTimeSavingTip] = useState(false);
  const [showFirstTimeModal, setShowFirstTimeModal] = useState(false)

  const { currentCollection } = useContext(CurrentCollectionContext);
  const isFromTellAStory = pathname?.includes('tell_a_story')
  const route = useCurrentCollectionRoute();
  const ftui = store.get('review_edit_ftui_watched');
  // Set (from story-detail.js) once the "first look" step is dismissed, so this
  // final congrats step shows last — see toggleFtuiFinalStepVisible's comment.
  const ftuiFinal = useFtuiFinalStepVisible();

  useEffect(() => {
    if (isFromEdit)
      if (setFirstTimeUserModal)
        setFirstTimeUserModal(!ftui || isFromTellAStory)
    if (isFromTellAStory) dispatch(togglefirstTimeUserFlowVisible(false))

    setShowFirstTimeModal(!ftui || isFromTellAStory)
  }, [ftui, isFromTellAStory])

  const toggleShowSubmit = () => setShowSubmit(prev => !prev);

  const handleEditClick = () => {
    if (isFromTellAStory)
      setShowSubmit(true)
    else {
      const basePath = isFromTellAStory ? '/tell_a_story' : '';
      const targetPath = isFromEdit ? `/story/${id}` : `/story/${id}/edit`;
      push(`${basePath}${targetPath}`);
    }
    if (refreshBookPages)
      refreshBookPages(id)
  };

  const handleEditSettingClick = () => {
    const basePath = isFromTellAStory ? '/tell_a_story' : '';
    push(`${basePath}/story/${id}/edit/settings`);
  };


  const handleSubmit = () => {
    push(`/tell_a_story/story/${id}/success`);
  };

  const onDone = () => {
    dispatch(togglefirstTimeUserFlowVisible(false));
    store.set('review_edit_ftui_watched', true);
    store.set('closeDrawer', false)
    const basePath = isFromTellAStory ? '/tell_a_story' : '';
    push(`${basePath}/story/${id}/edit`);
  }

  const onSoundsGreatPress = () => {
    alreadySeen = true
    store.set('review_edit_ftui_watched', true);
    setShowFirstTimeModal(false)
    if (!isFromTellAStory && setFirstTimeUserModal)
      setFirstTimeUserModal(false);
    if (ftui)
      dispatch(togglefirstTimeUserFlowVisible(false))

  };

  const renderLastStepFtui = () => (
    <Modal
      close={{
        onClose: () => {
          
          onDone();
          dispatch(toggleFtuiFinalStepVisible(false));
          setShowTimeSavingTip(true)
          dispatch(setSidebar(true))
        }
      }}
      maxWidth={620}
      closeOnOutsideClick={false}
      isScrollActive={false}
      aboveTooltip
      shadeProps={{ pt: [0, 4] }}
    >
      <Flex m="auto" mb={["150px", "50px"]} flexDirection="column" justifyContent="center" alignItems="center" maxWidth={400}>
        <Confetti
          height={height}
          width={width}
          style={{ pointerEvents: 'none' }}
          numberOfPieces={2000}
          recycle={false}
        />
        <Text px={2} fontFamily="Bitter" fontWeight="normal"
          sx={{
            color: '#000',
            fontFamily: 'Bitter',
            fontSize: '30px',
            fontWeight: '500',
            lineHeight: '165%',
          }}
        >
          You’re making progress on your baby book!
        </Text>
        <Image
          maxWidth={382}
          src={Congratulations}
        />
        <Text px={2} fontFamily="Poppins" fontWeight="normal"
          sx={{
            color: '#000',
            fontFamily: 'Poppins',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '150%',
            letterSpacing: '-0.096px',
          }}
        >
          Continue adding to your book in any of these ways:
        </Text>
        <Box mr="auto" >
          {MainOptions.map(({ icon, label }) => {
            return (
              <Flex p="12px 16px" >
                {icon()}
                <Text minWidth={130} ml="12px" fontSize={16} fontFamily="Poppins" fontWeight={400} lineHeight="150%" color="#000">
                  {label}
                </Text>
              </Flex>
            )
          })}
        </Box>
        <LetsBeginFooterComponent
          sx={{ justifyContent: 'center', }}
          onStepUp={() => {
            dispatch(toggleFtuiFinalStepVisible(false));
            onDone();
            setShowTimeSavingTip(true)
            dispatch(setSidebar(true))
          }}
          nextButtonText="Sounds Great!"
        />
      </Flex>
    </Modal>
  )


  const renderFtuiModal = () => (
    <Modal
      close={{
        onClose: onSoundsGreatPress
      }}
      maxWidth={620}
      closeOnOutsideClick={false}
      isScrollActive={false}
      aboveTooltip
      shadeProps={{ pt: [0, 4] }}
    >
      <Flex m="auto" mb="50px" flexDirection="column" justifyContent="center" alignItems="center" maxWidth={400}>
        <Text fontFamily="Bitter" fontWeight="normal"
          sx={{
            color: '#000',
            fontFamily: 'Bitter',
            fontSize: '30px',
            fontWeight: '500',
            lineHeight: '165%',
          }}
        >
          {isFromTellAStory ? 'Review, Edit & Finish ' : 'Review & Edit Story'}
        </Text>
        <Image
          maxWidth={382}
          src={ftuiReviewStory}
        />
        <Text
          px={2}
          color="#64748B"
          fontFamily="Poppins"
          fontSize="18px"
          fontStyle="normal"
          fontWeight={400}
          lineHeight="200%"
          letterSpacing="-0.36px"
          textAlign='center'
          mb="30px"
        >
          <br />
          {isFromTellAStory ? 'Review or edit your story' : 'Review or edit your story now or at anytime in the future'}
          <br />
          <br />
          Click <strong>{isFromTellAStory ? 'Finish' : 'Home'}</strong> {isFromTellAStory ? 'once you’re done.' : 'to return to your story dashboard'}
          {/* {!isFromTellAStory && <>
            <br />
            <br />
            Edit the story anytime from “All Stories” or in your “Chapters”
          </>} */}
        </Text>
        <LetsBeginFooterComponent
          sx={{ justifyContent: 'center', }}
          onStepUp={onSoundsGreatPress}
          nextButtonText="Okay"
        />
      </Flex>
    </Modal>
  )

  const renderModal = () => (
    <Modal
      close={{ onClose: toggleShowSubmit }}
      title="Finish Story"
      closeOnOutsideClick={false}
      isScrollActive={false}
      aboveTooltip
    >
      <Box maxWidth={420} m="auto" p={4}>
        <Text
          fontFamily="Poppins"
          textAlign="center"
          color="#64748B"
          fontSize="18px"
          fontWeight={400}
          lineheight="165%"
        >
          Are you sure you’re finished creating your story?
        </Text>
        <Flex flexDirection="column" alignItems="center" justifyContent="center" mt={3}>
          <Button
            width={200}
            sx={{ borderRadius: '23px' }}
            onClick={handleSubmit}
            height="44px"
            py="unset"
          >
            Yes, {isFromTellAStory ? "I'm Finished" : 'Submit'}
          </Button>
          <Button
            width={200}
            sx={{
              borderRadius: '23px',
              border: '1.5px solid #B0B0B0',
              color: '#B0B0B0',
            }}
            bg="transparent"
            onClick={toggleShowSubmit}
            height="44px"
            my={3}
            py="unset"
          >
            Continue Editing
          </Button>
        </Flex>
      </Box>
    </Modal>
  );

  const renderLogoOrBackButton = () => {
    if (isFromTellAStory) {
      return (
        <Box
          sx={{ display: ['none', 'none', 'block'] }}
          p={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Image src={greybfylogo} width={['160px', '200px']} />
        </Box>
      );
    }

    return <Flex
      height={40}
      width="min-content"
      justifyContent="space-around"
      alignItems="center"
      sx={{ borderRadius: 'medium', cursor: 'pointer' }}
      onClick={() => {
        const queryParams = new URLSearchParams(window.location.search);
        const reference = queryParams.get('ref');
        const pageIndex = queryParams.get('pageIndex');

        if (reference || pageIndex) {
          const url = new URL(state.from);

          const internalPath = url.pathname + url.search
          push(internalPath);
        }
        else
          goBack()
      }}
    >
      <Text as={IoIosArrowBack} color="mineShaft" size={24} />
      <Text minWidth={'max-content'} color="mineShaft" fontFamily="Poppins" lineHeight={'150%'} ml={1} fontWeight={400} fontSize="15px">
        Back
      </Text>
    </Flex>
  };

  const renderFinishButton = (display) => (
    <Button
      backgroundColor='brand'
      sx={{ display, borderRadius: '23px', }}
      onClick={handleEditClick}
      height="44px"
      my="auto"
      py="unset"
    >
      {isFromEdit ? (isFromTellAStory ?
        <Flex alignItems={'center'}>
          Submit Story
        </Flex>
        : <Flex alignItems={'center'}>
          <IoBookOutline color="#fff" size={18} />&nbsp;Story Preview
        </Flex>)
        : <Flex alignItems={'center'}>
          <BiEditAlt color="#fff" size={18} />&nbsp;  Edit Story
        </Flex>}
    </Button>
  );

  return (<>
    {showSubmit && renderModal()}
    {showFirstTimeModal && renderFtuiModal()}
    {ftuiFinal && renderLastStepFtui()}
    <AppInstallModal isOpen={showTimeSavingTip} onClose={() => setShowTimeSavingTip(false)} />
    <DetailNavOuter
      isFromEdit={isFromEdit}
      footerSx={footerSx}
      isFromTellAStory={isFromTellAStory}
      justifyContent="space-between"
    >
      {renderLogoOrBackButton()}
      <Flex width="100%" justifyContent={'flex-end'}>
        {/* {!isFromEdit && renderFinishButton('block')} */}
        {renderFinishButton('block')}
        {isFromTellAStory && <Button
          backgroundColor='brand'
          sx={{ borderRadius: '23px', }}
          onClick={() => {
            const existingReferrer = sessionStorage.getItem('fromMarcom');
            if (existingReferrer)
              window.open('https://babyyearbooks.com/pages/tell-a-story', '_blank', 'noopener,noreferrer');
            else
              setShowSubmit(true)
          }}
          height="44px"
          my="auto"
          ml={['auto', 2]}
          py="unset"
        >
          Finish
        </Button>}
      </Flex>
    </DetailNavOuter>
  </>
  );
};

export default connect(null, { setCheckmark })(StoryDetailHeaderNav);
